import React, { useEffect, useRef, useState } from "react";
import { ClipboardList, ChevronDown } from "lucide-react";
import { snippetsFor } from "@/lib/narrativeSnippets";

/**
 * A compact "Insert template" button that opens a popover list of canned
 * phrase starters for the given NarrativeField. Clicking one inserts the
 * text into the textarea at the end (appends with a space), then closes.
 */
export default function SnippetPicker({ fieldKey, onInsert, testid }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const items = snippetsFor(fieldKey);

  useEffect(() => {
    const h = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    if (open) document.addEventListener("click", h);
    return () => document.removeEventListener("click", h);
  }, [open]);

  const pick = (text) => {
    onInsert?.(text);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative inline-flex" data-testid={testid}>
      <button
        type="button"
        onClick={() => setOpen((x) => !x)}
        className="text-[11px] font-semibold px-2.5 h-6 rounded-full bg-[#FFFDEC] border border-[#DBB90A] text-[#8A6B00] hover:bg-[#fdf3de] transition inline-flex items-center gap-1"
        data-testid={`${testid}-toggle`}
        title="Insert a canned phrase starter — you'll edit it after"
      >
        <ClipboardList className="w-3 h-3" /> Templates
        <ChevronDown className="w-3 h-3" />
      </button>
      {open && (
        <div
          className="absolute right-0 top-[130%] z-40 w-[360px] max-h-[320px] overflow-y-auto rounded-xl bg-white shadow-[0_12px_36px_rgba(26,33,28,0.18)] border border-[#D6E3EF] py-1"
          data-testid={`${testid}-menu`}
        >
          <div className="px-3 py-2 text-[10.5px] uppercase tracking-[0.14em] font-semibold text-[#3A5275] border-b border-[#E7F1FB]">
            Click a starter to insert — then edit to fit this client
          </div>
          {items.map((t, i) => (
            <button
              key={t}
              type="button"
              onClick={() => pick(t)}
              className="block w-full text-left px-3 py-2 hover:bg-[#FFFDEC] border-b border-[#E7F1FB] last:border-b-0 text-[13px] text-[#0B1E3A] leading-snug"
              data-testid={`${testid}-item-${i}`}
            >
              {t}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
